import React from "react";
import { useHotkey } from "@react-hook/hotkey";
import { useDebounceCallback } from "@react-hook/debounce";

import {
  Tooltip,
  TextField as MuiTextField,
  InputAdornment,
} from "@mui/material";
import { Magnify as SearchIcon } from "mdi-material-ui";

const COMMAND_KEY =
  typeof window !== "undefined" && window.navigator.platform === "MacIntel"
    ? "⌘"
    : "Ctrl";

export default function SearchInput({
  disabled,
  onChange,
  debounce,
  ...props
}) {
  // Keyboard shortcut
  const inputRef = React.useRef();
  useHotkey(window, ["mod", "f"], (e) => {
    e.preventDefault();
    if (disabled) return;
    inputRef.current.focus();
  });

  // Debounce stuff
  const debouncedChange = useDebounceCallback(onChange, debounce);
  const handleChange = React.useCallback(
    (e) => debouncedChange(e.target.value),
    [debouncedChange]
  );

  return (
    <Tooltip title={`Rechercher (${COMMAND_KEY} + F)`}>
      <div>
        <MuiTextField
          {...props}
          onChange={handleChange}
          InputProps={{
            inputRef,
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </Tooltip>
  );
}

SearchInput.defaultProps = {
  placeholder: "Recherche",
  debounce: 400,
};
